import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Product from './product'
import ProductDetails from './product-details'
import ProductModify from './product-modify'

import './business.less'

export default class Business extends Component {
    render() {
        return (
            <Switch>
                <Route path='/work/business' component={Product} exact/> {/*exact = 路徑完全匹配*/}
                <Route path='/work/business/modify' component={ProductModify}/>
                <Route path='/work/business/details' component={ProductDetails}/>
                <Redirect to='/work/business' />
            </Switch>
        )
    }
}